// Generated sandbox code: SSVMN - PlusTools - Editor v - 30/07/2020
// Created/Updated by Developer - 10/27/2020

import { Component } from '@angular/core'
import { CtEmailFormComponent, HttpService, CtPreviewComponent, PlusAlertsService, CtButtonComponent, FormatTimePipe} from 'components';
import { Observable, Subscription, timer } from 'rxjs';
import { BaseController } from './base.controller';


@Component({
  selector: 'ac-vi99',
  template: `<div [id]="getId()" #target><div>`
})

export class AcVi99 extends BaseController {

  private readonly SEND_TIMEOUT_MINUTES: number = 10;
  private report: any;
  private sendTimer: Subscription;
  private sendBtn: CtButtonComponent;
  private formatter: FormatTimePipe;
  private recipients: string[];
  public counter: number;
  private openDialog: boolean;

  constructor(plusAlertService: PlusAlertsService) {
    super();
    this.setViewCode('AC_VI99');
    this.formatter = new FormatTimePipe();
  }

  /* ---------------------- CONTROLLER LOGIC ------------------- */

  genEstadoCuenta(e: any): void {
    this.requestReportData(this.loggedUser.user.num_cliente_sigma, []).subscribe((res) => {
      if (!res && !res.data) {
        this.plusAlertService.setCtDialogInfo('ERROR', 'downloadError', 'downloadError', 'primary', 'Debe ingresar un correo',
          true, 'Aceptar', 'Cancelar');
      }

      let preview: CtPreviewComponent = this.view.getChildById(this.utilService.getParsedId(e.actionParams[0]), true);
      this.report = res.data[0];

      var url = 'assets/web/viewer.html?file=';
      let data = this.utilService.getBinaryUrl(this.report, 'application/pdf');
      if (preview) {
        preview.setSrc(url + encodeURIComponent(data) + '&fileName=' + 'ESTADO_CUENTA_' + this.loggedUser.user.num_cliente_sigma);
      }
    })

  }

  sendReportViaEmail(e: any): void {
    let emailForm: CtEmailFormComponent = this.view.getChildById(this.utilService.getParsedId(e.actionParams[0]), true);
    let recipients = emailForm.recipients.map((x) => x.value) || [];
    recipients.push(this.loggedUser.user.email ? this.loggedUser.user.email : '');

    if (recipients[0] == '' && this.loggedUser.user.email) {
      recipients[0] = this.loggedUser.user.email;
    } else if (!recipients[0]) {

      this.plusAlertService.setCtDialogInfo('ERROR', 'downloadError', 'downloadError', 'primary', 'Debe ingresar un correo',
        true, 'Aceptar', 'Cancelar');
    }


    this.recipients = [];

    for (let email of recipients) {
      if (email)
        this.recipients.push(email);
    }

    if (!this.sendBtn)
      this.sendBtn = this.view.getChildById(this.utilService.getParsedId(e.actionParams[2]), true);

    this.sendBtn.event2('onCustomEvent');
  }

  requestReportData(num_cliente: number, recipients: string[]): Observable<any> {

    let reportReq = {
      "format": "PDF",
      "source": this.getViewCode(),
      "sendTo": recipients,
      "parameters": [
        {
          "name": "P_NUM_CLIE",
          "value": num_cliente
        },
        {
          "name": "P_FEC_CAL",
          "value": this.datePipe.transform(new Date(), 'd/M/yyyy')
        },
        {
          "name": "P_NUM_EMP",
          "value": "5"
        }
      ]
    };

    return this.httpService.post(HttpService.ENDPOINT + '/api/Report/Generate/ST_RE10', reportReq);
  }

  downloadReport(): void {
    try {
      let byteArray = this.utilService.getByteArray(this.report);
      let blob = new Blob([byteArray], { type: 'application/pdf' });
      this.utilService.createAdownloadATag(blob, 'ESTADO_CUENTA_' + this.loggedUser.user.num_cliente_sigma);
    } catch (error) {
      throw new Error("");
    }
  }

  startTimer(e: any): void {
    let htmlEmailList = '<br><br><ul>';
    this.recipients.forEach(x => htmlEmailList += '<li>' + x + '</li>');
    htmlEmailList += '</ul>'


    this.plusAlertService.setCtDialogInfo('Solicitud completada', 'success', 'success', 'primary', 'Estimado(a) asociado(a), el estado de cuenta ha sido enviado satisfactoriamente a los siguientes correos electrónicos:' + htmlEmailList,
      true, 'Aceptar', '');


    this.counter = this.SEND_TIMEOUT_MINUTES * 60;
    this.sendBtn.setDisabled(true);
    this.sendTimer = timer(0, 1000).subscribe(() => {
      if (this.counter == 0)
        this.stopTimer();
      else {
        --this.counter;
        this.sendBtn.setButtonText(`Reintentar en ${this.formatter.transform(this.counter)}`);
      }
    });
  }

  private stopTimer(): void {
    this.sendTimer.unsubscribe();
    this.counter = 0;
    this.sendBtn.setDisabled(false);
    this.sendBtn.setButtonText('Enviar');
  }

  /* -------------------- END CONTROLLER LOGIC ----------------- */

}
